import { CountingSchemes } from '@ahaslides-product/frontend-toolkit'
import sentry from '@/3rd-parties/sentry'

const SEED_RETRIES = 1

const report = (error) => sentry.captureException(error)

const countingGroups = (presentationId, slide) => [
  CountingSchemes.answerCountPerAnswerValue({
    presentationId,
    slideId: slide.id,
    slideVersion: slide.version,
  }),
]

const countingActions = {
  subscribeCountingForSlideAction: ({ dispatch, getters, rootState }, { slide }) => {
    if (!getters.canReadAnswertextFromCounting || !slide?.id) return
    try {
      dispatch('counting/subscribe', {
        groups: countingGroups(rootState.presentation.id, slide),
        retries: SEED_RETRIES,
        onError: report,
      }, { root: true }).catch(report)
    } catch (error) {
      report(error)
    }
  },

  unsubscribeCountingForSlideAction: ({ dispatch, rootState }, { slide }) => {
    if (!slide?.id || !rootState?.presentation?.id) return
    try {
      dispatch('counting/unsubscribe', {
        groups: countingGroups(rootState.presentation.id, slide),
      }, { root: true })
    } catch (error) {
      report(error)
    }
  },
}

export default countingActions
